export default class Faktura {

    public id: number;
    public idObjednavka: number;
    public idFaktura: number;
    public idSubjekt: number;
    public price: number;
    public number: string;
    public status: string;
    public publicLink: string;

    public clone(): Faktura {
        const newDen: Faktura = new Faktura();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Faktura {
        this.id = json.id;
        this.idObjednavka = json.id_objednavka;
        this.idSubjekt = json.id_subject;
        this.idFaktura = json.id_faktura;
        this.price = json.price;
        this.number = json.cislo;
        this.status = json.status;
        this.publicLink = json.public_link;
        return this;
    }

    public loadFromEntity(ent: Faktura): Faktura {
        this.id = ent.id;
        this.idFaktura = ent.idFaktura;
        this.idObjednavka = ent.idObjednavka;
        this.idSubjekt = ent.idSubjekt;
        this.price = ent.price;
        this.number = ent.number;
        this.status = ent.status;
        this.publicLink = ent.publicLink;
        return this;
    }

}


// WEBPACK FOOTER //
// ./src/models/Faktura.tsx